var _defs, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 234 153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 234,
    height: 31,
    rx: 8.3,
    ry: 8.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 62,
    width: 234,
    height: 31,
    rx: 8.3,
    ry: 8.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 122,
    width: 234,
    height: 31,
    rx: 8.3,
    ry: 8.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.999a2f4230f74f337f71aaedb29b78bb.svg";
export { ForwardRef as ReactComponent };